import React from "react";
import Head from "next/head";

import HelpMain from "@/components/help/help-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const HelpPage = () => {
  return (
    <>
      <Head>
        <title>{seoData.HELP_CENTER.title}</title>
        <SeoMetaData data={seoData.HELP_CENTER} />
      </Head>

      <HelpMain />
    </>
  );
};

export default HelpPage;
